// extracted by mini-css-extract-plugin
export default {"loading":"CategoryList_loading__n1ZJ7","wrapper":"CategoryList_wrapper__Aea6Q","button":"CategoryList_button__tiSKS"};